import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

export const Link: React.FC<
  React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
> = ({ children, ...rest }) => {
  const device = useDeviceType();

  const target = device === 'desktop' ? '_blank' : undefined;

  return (
    <a target={target} {...rest} rel="noopener noreferrer">
      {children}
    </a>
  );
};
